<button
  class="prompt-button no-style"
  (click)="press.emit()">
  <ng-content></ng-content>
</button>
